import { BoxSize, HeatPumpSize } from '~src/gql';

export const sizeIsBox = (size: HeatPumpSize): size is BoxSize => !!(size as BoxSize).depth;

export type GetElementType<T extends unknown[] | undefined> = T extends (infer U)[] ? U : never;
